import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../components/Col';
import { Container } from '../../../components/Container';
import { CustomButton } from '../../../components/CustomButton';
import InsertDriveFileIcon from '../../../components/Icons/InsertDriveFileIcon';
import { Row } from '../../../components/Row';
import { TemplateContratoItem } from '../../../components/TemplateContratoItem';
import UnauthorizedScreen from '../../../components/UnauthorizedScreen/UnauthorizedScreen';
import { contratosRoute } from '../../../library/Routes';
import {
  clearAllTemplates,
  loadAllTemplates,
} from '../../../store/modules/ContratosActions';
import { isAuthorizedRequest } from '../../../utils/httpResponseHandlers';
import { getElementID } from '../../../utils/HTMLUtils';
import styles from './Templates.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-templates';

class Templates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorizedRequest: true,
      searching: true,
    };
  }

  UNSAFE_componentWillMount() {
    this.toSearch();
  }

  changeSearchingStatus = (isSearching, moreProps = {}) => {
    if (isSearching !== this.state.searching) {
      this.setState({
        ...this.state,
        searching: isSearching,
        ...moreProps,
      });
    }
  };

  toSearch = () => {
    this.changeSearchingStatus(true);
    this.props.loadAllTemplates(
      () => {
        this.changeSearchingStatus(false);
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeSearchingStatus(false);
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorSearchingTemplatesContratos,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeSearchingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  };

  refreshList = () => {
    this.toSearch();
  };

  componentWillUnmount() {
    this.props.clearAllTemplates();
  }

  getLegendResults = () => {
    let legend = '';
    const totalItems =
      this.props.contratos.allTemplates &&
      typeof this.props.contratos.allTemplates.length === 'number'
        ? this.props.contratos.allTemplates.length
        : 0;
    if (totalItems === 1) {
      legend =
        this.props.languageValues.legendTemplatesContratosResultSingularEmpty;
    } else {
      legend =
        this.props.languageValues.legendTemplatesContratosResultPluralEmpty;
    }
    return (
      legend
        /* eslint-disable-next-line */
        .split('${1}')
        .join(totalItems)
    );
  };

  render() {
    return this.state.authorizedRequest &&
      this.props.auth.userPermissions.contratos.assessor.templates.list ? (
      <Container className={rootClassName + '-container container-fluid'}>
        <div className='container-fluid'>
          <Row className={rootClassName + '-header'}>
            <Col cols={[12, 12, 4, 3, 3]}>
              <CustomButton
                theme='pufvYellow'
                id={getElementID(rootElementId, 'back-to-contratos')}
                className={rootClassName + '-back-to-contratos-button'}
                label={this.props.languageValues.backToContratosButton}
                rightIcon={<InsertDriveFileIcon />}
                onClick={() => {
                  this.props.history.push(contratosRoute.path);
                }}
              />
            </Col>
          </Row>
          {!this.state.searching ? (
            <Row>
              <Col cols={[12, 12, 12, 12, 12]}>{this.getLegendResults()}</Col>
            </Row>
          ) : (
            ''
          )}
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + '-list-items'}
            >
              {this.props.contratos.allTemplates.map((template, index) => {
                return (
                  <TemplateContratoItem
                    template={template}
                    id={getElementID(rootElementId, 'item-' + index)}
                    key={index}
                  />
                );
              })}
            </Col>
          </Row>
        </div>
      </Container>
    ) : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadAllTemplates,
      clearAllTemplates,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Templates));
